import type { SchedulingLeg } from '../types/scheduling';

export function prepullConflict(
  leg: SchedulingLeg,
  proposedDate?: string | null,
  today = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Chicago' }).format(new Date()),
): string | null {
  const delivery = leg.confirmed_delivery_date?.slice(0, 10);
  if (!leg.prepull_needed || !delivery) return null;
  if (delivery < today) return 'Delivery conflict: confirmed delivery is in the past';
  const earliest = [today, leg.available_date, leg.eta_date, leg.first_rcv_date, proposedDate]
    .filter((value): value is string => !!value && value.slice(0, 10) > '0000-00-00')
    .map(value => value.slice(0, 10)).reduce((latest, value) => value > latest ? value : latest, today);
  return delivery < earliest
    ? `Delivery conflict: confirmed delivery is before pre-pull availability (${earliest})`
    : null;
}


export function isSchedulerLegSelectable(leg: SchedulingLeg): boolean {
  if (leg.prepull_needed) return !['PENDING', 'PENDING_CUSTOMER', 'HOLD'].includes(leg.schedule_status || '');
  return leg.schedule_status === null || ['PLANNING', 'PENDING_APPT', 'RETURNED'].includes(leg.schedule_status || '');
}

export function missingSchedulingDate(leg: SchedulingLeg): boolean {
  return leg.prepull_needed
    ? !leg.proposed_prepull_date
    : !leg.proposed_appt_date && !leg.proposed_prepull_date;
}
